type TransformClosingPriceChangeDataType = {
  Y: string;
  P: number;
  V: number;
  Vp: number;
  TTV: number;
  TST: number;
};
function transformClosingPriceChange(
  data: TransformClosingPriceChangeDataType
) {
  const {
    Y: isin,
    P: closingPrice,
    V: closingPriceVariation,
    Vp: closingPriceVariationPercent,
    TTV: totalTradeValue,
  } = data;

  return {
    isin,
    closingPrice,
    closingPriceVariation,
    closingPriceVariationPercent,
    closingPriceVariationPercentage: closingPriceVariationPercent,
    totalTradeValue,
  };
}

export { transformClosingPriceChange };
